<template>
  <div class="block">
    <div class="line">
      <div class="line-name">
        订单号
      </div>
      <div class="line-value">
        {{orderDetail.order_no}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        订单类型
      </div>
      <div class="line-value"
        v-if="orderDetail.type === 1"
      >
        购买
      </div>
      <div class="line-value"
        v-if="orderDetail.type === 2"
      >
        升级
      </div>
      <div class="line-value"
        v-if="orderDetail.type === 3"
      >
        续费
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        订单内容
      </div>
      <div class="line-value">
        {{orderCont}}{{orderContOne}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        客户成交价格
      </div>
      <div class="line-value">
        {{orderDetail.customer_price}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        代理成交价格
      </div>
      <div class="line-value">
        {{orderDetail.special_agent_price}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        是否为特殊订单
      </div>
       <div class="line-value"
        v-if="orderDetail.is_special === 0"
       >
       否
      </div>
      <div class="line-value"
        v-if="orderDetail.is_special === 1"
      >
       是
     </div>
    </div>
    <div class="line">
      <div class="line-name">
        订单备注
      </div>
      <div class="line-value">
        {{orderDetail.special_remark}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        企业名称
      </div>
      <div class="line-value">
        {{orderDetail.ep_name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        CorpID
      </div>
      <div class="line-value">
        {{orderDetail.corpid}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        代理商
      </div>
      <div class="line-value">
        {{orderDetail.agent_name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        代理商业务员
      </div>
      <div class="line-value">
        {{orderDetail.order_user_name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderDetail: {
      type: Object,
      required: true
    },
    buyPeople: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      orderCont: '2'
    }
  },
  computed: {
    orderContOne () {
      let Year = this.orderDetail.use_year_type
      for (var item of this.buyPeople) {
        if (item.value === this.orderDetail.fk_t_charge_package_id) {
          if (this.orderDetail.type === 2) {
            if (this.orderDetail.fk_t_charge_package_id === 8) {
              this.orderCont = '不限工号'
            } else {
              this.orderCont = item.maxNum + '用户'
            }
          } else {
            if (this.orderDetail.fk_t_charge_package_id === 8) {
              this.orderCont = '不限工号' + Year + '年'
            } else {
              this.orderCont = item.maxNum + '用户' + Year + '年'
            }
          }
        }
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.block {
  border-top: 1px #DDDEE1 dashed;
  padding-bottom: 11px;

  .line {
    display: flex;
    padding-top: 10px;
    line-height: 20px;

    .line-name {
      width: 100px;
      font-size: 12px;
      color: #405060;
    }

    .line-value {
      width: 168px;
      margin-left: 10px;
      font-size: 12px;
      color: #80848F;
      overflow: hidden;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/agOrderPay/OrderDetailLeft.vue